import DOMPurify from 'dompurify';

// Links in untrusted HTML (e.g. received mail) should never navigate the app tab.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Strips scripts, event handlers, javascript: URLs, forms and other active
// content so the result is safe for dangerouslySetInnerHTML / html-react-parser.
// Inline style attributes are kept (HTML mail depends on them); <style> tags are
// dropped because they would apply to the whole page.
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || '', {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select'],
  });
